import { Box } from '@mui/material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Tooltip } from '@agronod/mui-components';
import { MATT_STATUS_TEXT, MattStatus } from '../../utils/api';

const EJ_BEDOMD = 'Ingår inte i gårdens bedömning';

/**
 * Måttets läge, eller `ej_bedomd` när modellen inte bedömer gården alls
 * (den gemensamma listan över ej utvalda gårdar visar båda modellernas mått).
 */
export type CellStatus = MattStatus | 'ej_bedomd';

/**
 * En symbol per mått: pil upp/ned i varningsfärg utanför intervallet, punkt
 * inom, streck utan värde eller när modellen inte bedömer gården. Tom cell
 * när måttet saknas i gårdens rad (urval låsta innan status per mått infördes).
 */
export const StatusCell = ({ status }: { status: CellStatus | undefined }) => {
  if (!status) {
    return (
      <Box
        role="img"
        aria-label={EJ_BEDOMD}
        title={EJ_BEDOMD}
        sx={{ width: 32, height: 24, mx: 'auto' }}
      />
    );
  }
  const utanfor = status === 'over' || status === 'under';
  const text = status === 'ej_bedomd' ? EJ_BEDOMD : MATT_STATUS_TEXT[status];
  return (
    <Tooltip title={text}>
      <Box
        role="img"
        aria-label={text}
        sx={{
          width: 32,
          height: 24,
          mx: 'auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 999,
          bgcolor: utanfor ? 'warning.pastel' : 'transparent',
          color: utanfor ? 'warning.dark' : 'gray500',
          fontSize: 16,
          lineHeight: 1,
        }}
      >
        {status === 'over' && <ArrowUpwardIcon fontSize="inherit" />}
        {status === 'under' && <ArrowDownwardIcon fontSize="inherit" />}
        {status === 'inom' && (
          <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: 'gray400' }} />
        )}
        {(status === 'saknas' || status === 'ej_bedomd') && '–'}
      </Box>
    </Tooltip>
  );
};
